export const formatCountdown = (totalSeconds, withSeconds = false) => {
  const secondsNumber = Number(totalSeconds)

  if (!Number.isFinite(secondsNumber) || secondsNumber <= 0) {
    return "0H 0M 0S"
  }

  const days = Math.floor(secondsNumber / 86400)
  const hours = Math.floor((secondsNumber % 86400) / 3600)
  const minutes = Math.floor((secondsNumber % 3600) / 60)
  const seconds = Math.floor(secondsNumber % 60)

  if (days > 0) {

    return withSeconds
      ? `${days}D ${hours}H ${minutes}M ${seconds}S`
      : `${days}D ${hours}H ${minutes}M`
  }

  return `${hours}H ${minutes}M ${seconds}S`
}
